import { FetchResult } from "configcat-common";

var HttpConfigFetcher =
/** @class */
function () {
  function HttpConfigFetcher() {}

  HttpConfigFetcher.prototype.fetchLogic = function (options, lastEtag, callback) {
    var httpRequest = new XMLHttpRequest();

    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4) {
        var etag = httpRequest.getResponseHeader("ETag");

        if (httpRequest.status === 200) {
          callback(FetchResult.success(httpRequest.responseText, etag));
        } else if (httpRequest.status === 304) {
          callback(FetchResult.notModified());
        } else {
          options.logger.error("Failed to download feature flags & settings from ConfigCat. " + httpRequest.status + " - " + httpRequest.statusText);
          callback(FetchResult.error());
        }
      }
    };

    httpRequest.open("GET", options.getUrl(), true);
    httpRequest.timeout = options.requestTimeoutMs;
    httpRequest.setRequestHeader("X-ConfigCat-UserAgent", options.clientVersion);
    httpRequest.setRequestHeader("Cache-Control", "no-cache"); // any locally cached version isn't trusted without the server's say-so

    if (lastEtag) {
      httpRequest.setRequestHeader("If-None-Match", lastEtag);
    }

    httpRequest.send(null);
  };

  return HttpConfigFetcher;
}();

export { HttpConfigFetcher };